__turbopack_context__.v({
  "buttons": "jkBsyW_buttons",
  "container": "jkBsyW_container",
  "icon": "jkBsyW_icon",
  "note": "jkBsyW_note",
  "shrink-down": "jkBsyW_shrink-down",
});
